import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable, map, shareReplay } from 'rxjs';

import { EnvironmentConfig } from '../../client-config/index';
import { IAccaIns } from './acca-insurance.model';

@Injectable()
export class AccaInsuranceCmsService {
    accaData: Observable<any>;
    private readonly environment = inject(EnvironmentConfig).configuration;
    CMS_ENDPOINT: string = this.environment.CMS_ENDPOINT as string;
    brand: string = this.environment.BRAND as string;

    constructor(private http: HttpClient) {}

    /**
     * @param  {string} url
     * @param  {any={}} params
     * @returns Observable
     */
    getData<T>(url: string, params: any = {}): Observable<HttpResponse<T>> {
        return this.http.get<T>(`${this.CMS_ENDPOINT}/${this.brand}/${url}`, {
            observe: 'response',
            params: params,
        });
    }

    /**
     * gets the CMS congigurations of Acca insurance
     * @returns
     */
    getAccaInsuranceConfig(): Observable<IAccaIns> {
        if (this.accaData) {
            return this.accaData;
        }
        this.accaData = this.getData(`acca-insurance`).pipe(
            map((data: HttpResponse<IAccaIns>) => data.body),
            shareReplay(1),
        );
        return this.accaData;
    }
}
